import { date as dateSort } from 'scripts/utilities/sorters';

const monthlyUpdatesGetter = (state) => state.monthlyUpdates;

export const monthlyUpdatesSelector = (state) => ({
  monthlyUpdates: monthlyUpdatesGetter(state)::dateSort(false)
});
